import request from '@/utils/request'

/**
 * 新增项目
 */
export function knowledgeAdd(data) {
  return request({
    url: '/api/knowledge/add',
    method: 'PUT',
    data
  })
}

/**
 * 保存项目
 */
export function knowledgeSave(data) {
  return request({
    url: '/api/knowledge/save',
    method: 'POST',
    data
  })
}

/**
 * 删除项目
 */
export function knowledgeDel(data) {
  return request({
    url: '/api/knowledge/del',
    method: 'POST',
    data
  })
}

/**
 * 获取项目
 * */
export function getKnowledgeList(data) {
  return request({
    url: '/api/knowledge/list',
    method: 'GET',
    params: data
  })
}

/**
 * 新增项目
 */
export function knowledgeDocGroupAdd(data) {
  return request({
    url: '/api/knowledge/add-doc-group',
    method: 'PUT',
    data
  })
}

/**
 * 对话保存到项目
 */
export function chatSaveToDoc(data) {
  return request({
    url: '/api/knowledge/chat-save-to-doc',
    method: 'PUT',
    data
  })
}

/**
 * 网页保存到项目
 */
export function webSaveToDoc(data) {
  return request({
    url: '/api/knowledge/web-save-to-doc',
    method: 'POST',
    data
  })
}

/**
 * 保存项目
 */
export function knowledgeDocGroupSave(data) {
  return request({
    url: '/api/knowledge/save-doc-group',
    method: 'POST',
    data
  })
}

/**
 * 删除项目
 */
export function knowledgeDocGroupDel(data) {
  return request({
    url: '/api/knowledge/del-doc-group',
    method: 'POST',
    data
  })
}

/**
 * 获取项目
 * */
export function knowledgeDocGroupList(data) {
  return request({
    url: '/api/knowledge/doc-group-list',
    method: 'GET',
    params: data
  })
}

/**
 * 项目分组移动
 */
export function updateKnowledgeDocItem(data) {
  return request({
    url: '/api/knowledge/update-doc-item',
    method: 'POST',
    data
  })
}

/**
 * 项目分组排序
 */
export function knowledgeDocGroupSort(data) {
  return request({
    url: '/api/knowledge/doc-group-sort',
    method: 'POST',
    data
  })
}

/**
 * 获取项目
 * */
export function getKnowledgeDocList(data) {
  return request({
    url: '/api/knowledge/doc-list',
    method: 'GET',
    params: data
  })
}

/**
 * 获取项目
 * */
export function getKnowledgeDetail(data) {
  return request({
    url: '/api/knowledge/info',
    method: 'GET',
    params: data
  })
}
/**
 * 更新项目浏览量
 */
export function upKnowledgeDocPv(data) {
  return request({
    url: '/api/knowledge/up-pv',
    method: 'POST',
    data
  })
}

/**
 * 获取文档详情
 */
export function getKnowledgeDocInfo(data) {
  return request({
    url: '/api/knowledge/get-doc-info',
    method: 'POST',
    data
  })
}

export function pdfFileAnalysisById(data) {
  return request({
    url: '/api/knowledge/file-analysis-by-id',
    method: 'POST',
    data,
    timeout: 3600000
  })
}

export function getFileAnalysis(data) {
  return request({
    url: '/api/knowledge/get-file-analysis',
    method: 'POST',
    data,
    timeout: 60000
  })
}

/**
 * 保存在线文档
 */
export function saveKnowledgeOnlineDoc(data) {
  return request({
    url: '/api/knowledge/save-online-doc',
    method: 'POST',
    data
  })
}

/**
 * 获取在线文档
 */
export function getOnlineDocInfo(data) {
  return request({
    url: '/api/knowledge/get-online-info',
    method: 'POST',
    data
  })
}

/**
 * 获取在线网页
 */
export function getOnlineWebInfo(data) {
  return request({
    url: '/api/knowledge/get-web-info',
    method: 'POST',
    data
  })
}

/**
 * 给聊天机器人发送消息
 */
export function docSendAgentMessage(data) {
  return request({
    url: '/api/knowledge/agent-send-message',
    method: 'post',
    timeout: 3600000,
    data
  })
}
export function getWikiCoverList(data) {
  return request({
    url: '/api/knowledge/get-wiki-space-cover-list',
    method: 'GET',
    params: data
  })
}
export function getKnowledgeBaseInfo(data) {
  return request({
    url: '/api/knowledge/doc-info-by-uniq-code',
    method: 'POST',
    params: data
  })
}

/**
 * 服务端导出知识库文档 PDF（Gotenberg）
 * 成功返回 application/pdf blob；业务失败返回 HTTP 200 + JSON blob {code, message}
 */
export function exportKnowledgeDocPdf(data) {
  return request({
    url: '/api/knowledge/export-pdf',
    method: 'POST',
    data,
    responseType: 'blob',
    timeout: 130000
  })
}

/**
 * PDF 打印页内部数据接口（免登录，一次性令牌鉴权）
 */
export function getInternalPdfDocument(data) {
  return request({
    url: '/api/internal/pdf-document',
    method: 'GET',
    params: data,
    suppressBusinessErrorMessage: true
  })
}
